import { COLORS, borderRadiusSm } from 'assets/styled';
import { respondTo } from 'assets/styled/breakpoints';
import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  background-color: ${COLORS.WHITE};
  border-radius: ${borderRadiusSm};
  padding: 30rem;

  ${respondTo.midTablet`
    padding: 20rem;
  `}
`;

export const CompaniesLabel = styled.label`
  color: ${COLORS.BLACK};
  font-size: 24rem;
  font-weight: 400;
  flex: 1;

  ${respondTo.smallLaptop`
    font-size: 22rem;
  `}
`;

export const FirstRow = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 30rem;
`;

export const RowWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  gap: 20rem;

  ${respondTo.bigTablet`
    align-items: flex-start;
  `}

  ${respondTo.midTablet`
    flex-direction: column;
    gap: 20rem;
  `}
`;

export const InputWrapper = styled.div`
  width: 300rem;

  ${respondTo.smallTablet`
    width: 100%;
  `}
`;

export const LeftSide = styled.div`
  display: flex;
  align-items: center;
  gap: 20rem;

  ${respondTo.midTablet`
    align-self: flex-start;
  `}

  ${respondTo.bigPhone`
    flex-direction: column;
    gap: 10rem;
    width: 100%;
  `}
`;

export const RightSide = styled.div`
  display: flex;
  align-items: center;
  gap: 20rem;

  ${respondTo.horizontalTablet`
    width: 100%;
    flex-wrap: wrap-reverse;
    justify-content: flex-end;
  `}

  ${respondTo.midTablet`
    align-self: flex-end;
  `}

  ${respondTo.bigPhone`
    flex-direction: column;
    gap: 20rem;
    width: 100%;
  `}
`;

export const ToggleGroupWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 10rem;
`;

export const ToggleLabel = styled.label`
  font-size: 16rem;
  font-weight: 400;
  color: ${COLORS.GREEN};
`;

export const NoContentLabelWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const NoContentLabel = styled.label`
  width: 100%;
  text-align: center;
  font-weight: 300;
  font-size: 18rem;
  line-height: 27rem;
  color: ${COLORS.BLACK};

  ${respondTo.midTablet`
    font-size: 16rem;
  `}
`;

export const AddLabel = styled.label`
  font-size: 18rem;
  font-weight: 400;
  color: ${COLORS.GREEN};
  cursor: pointer;

  ${respondTo.midTablet`
    font-size: 16rem;
  `};
`;

export const AddWrapper = styled.div`
  display: flex;
  gap: 2rem;
  cursor: pointer;

  ${respondTo.midTablet`
    order: 2;
  `};

  &:hover {
    ${AddLabel} {
      text-decoration: underline;
    }
  }
`;
